
import request from '../../util/request'
import centerRequest from '../../util/centerRequest'
export function getInfo () {
  return request.get('/system/user/info')
}

export function loginMp (parameter) {
  return request.get('/auth/loginMp', parameter)
}
export function loginActivity (parameter) {
  return request.get('/auth/loginActivity', parameter)
}
export function getSign (parameter) {
  return request.post('/system/mp/util/getSign', parameter)
}
export function loginWxMulti (parameter) {
  return request.post('/auth/loginMpMulti', parameter)
}
export function getMpSwitchList (parameter) {
  return request.post('/auth/getMpSwitchList', parameter)
}
export function mpSwitch (parameter) {
  return request.post('/auth/mpSwitch', parameter)
}
export function loginMpBind (parameter) {
  return request.post('/auth/loginMpBind', parameter)
}
export function login (parameter) {
  return request.post('/auth/login', parameter)
}
export function registerAccount (parameter) {
  return request.post('/system/user/register', parameter)
}
export function switchWxCheck (parameter) {
  return request.get('/system/wx/switchWxCheck', parameter)
}
export function getLoginCode (parameter) {
  return request.post('/auth/login/validateCode', parameter)
}
export function autocode (parameter) {
  return request.post('/system/user/autocode', parameter)
}
export function autologin (parameter) {
  return request.post('/auth/autologin', parameter)
}
export function checkoutCode (parameter) {
  return request.get('/system/user/checkoutCode', parameter)
}
export function reSetPassWord (parameter) {
  return request.post('/system/user/resetPassword', parameter)
}

export function logout () {
  return request.post('/auth/logout')
}
// 公共下载方法
export function downLoadFiles (parameter) {
  let url = '/downloadimg?path=' + parameter.path + '&fileName=' + parameter.fileName
  window.location.href = url
}

// 获取协议
export function getSysAgreementByType (parameter) {
  return centerRequest.get('/business/sysAgreement/getByType', parameter)
}



// WEBPACK FOOTER //
// ./src/api/login/index.js